import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { PayService } from 'src/app/core/services/pay.service';
import { MaterialModule } from 'src/app/core/material/material.module';
import { PayOrderComponent } from './pay-order.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { Permissions } from 'src/app/core/enums/permissions.enum';

@NgModule({
  declarations: [PayOrderComponent],
  exports: [PayOrderComponent],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: PayOrderComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'components.breadcrumb.link',
          permission: Permissions.COBRAR,
          status: true
        }
      }
    ]),
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    NgxMatSelectSearchModule,
    TranslateModule.forChild({
      isolate: false
    }),
    MatProgressSpinnerModule
  ],
  providers: [PayService]
})
export class PayOrderModule {}
